<template>
    <div class="basis unselectable onTopContainer" :style="{width: width, 'min-width': width}" :class="{small: small}"> 
        <div class="title" :style="{background: background, color: color, borderColor: borderColor}">
            <slot name="title"/>
        </div>
        <div class="box onTopContainer" :style="{'max-width': width, borderColor: borderColor}">
            <div style="display: flex; flex-wrap: wrap; height: max-content; width: 100%;"  >
                <slot name="content"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Box",
    props:{
        background:{
            type: String,
            default: "#e8f0fe"
        },
        color:{
            type: String,
            default: "#1967D2"
        },
        borderColor: {
            type: String,
            default: '#dcdcdc'
        },
        width:{
            type: String,
            default: "100%"
        },
        small:{
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.basis{
    padding: 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    min-width: 100px;
    min-height: 100px;
    height: max-content;
    width: 100%;
    max-width: 100%;
    flex-direction: column; 
}

.title{
    display: flex;
    color: #1967D2;
    background: #e8f0fe;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    height: max-content;
    min-height: 50px;
    justify-content: space-between;
    width: 100%;
    max-width: 100%;
    border: 1px solid #dcdcdc;
    align-items: center;
    padding: 0 20px;
    font-size: 16px;
    font-weight: 600;
}

.basis.small .title{
    height: 40px;
    min-height: 40px;
    padding: 0 10px;
    font-size: 14px;
}

.box{
    background: #fff;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border: 1px solid #dcdcdc;
    border-top: 0;
    min-height: 80px;
    width: 100%;
    display: flex;
    padding: 8px;
    flex-wrap: wrap;
    transition: height .2s ease-in-out;
    min-height: max(80px, max-content); 
    z-index: -1;
}

.box:has(.drag){
    z-index: 1;
}

.box:has(.drop){
    z-index: 1;
}

.onTopContainer:has(.onTop){
    z-index: 1;
}

</style>